<template>
  <div
    class="page vertical-align text-center"
    data-animsition-in="fade-in"
    data-animsition-out="fade-out"
  >
    <div
      class="page-content vertical-align-middle animation-slide-top animation-duration-1"
    >
      <div
        class="brand mobile-page"
        :style="{ margin: '0px auto 75px auto', width: '200px' }"
      >
        <img
          class="brand-img"
          style="width: 100%"
          src="//files.shebah.com.au/portal/business/img/Shebah-For-Business-Logo.png"
          alt="..."
        />
      </div>
      <h2>Accept Invite</h2>
      <p v-if="!inviteData.status">
        Before you can start using <b>{{ inviteData.group }}</b> Workplace
        portal please provide us with some more information.
      </p>
      <p v-else>
        Before you can start using <b>{{ inviteData.group }}</b> Workplace
        portal please accept the invitation.
      </p>

      <b-form @submit.prevent="onSubmit" v-if="!successMessage">
        <div v-if="!inviteData.status">
          <b-form-group
            label="First name"
            :invalid-feedback="formErrors.firstName"
            :state="typeof formErrors.firstName !== 'undefined' ? false : true"
          >
            <b-form-input
              v-model="form.firstName"
              type="text"
              required
              placeholder="Your name"
              :state="
                typeof formErrors.firstName !== 'undefined' ? false : null
              "
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Last name"
            :invalid-feedback="formErrors.lastName"
            :state="typeof formErrors.lastName !== 'undefined' ? false : true"
          >
            <b-form-input
              v-model="form.lastName"
              type="text"
              required
              placeholder="Your name"
              :state="typeof formErrors.lastName !== 'undefined' ? false : null"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Password"
            label-for="password"
            :invalid-feedback="formErrors.password"
            :state="typeof formErrors.password !== 'undefined' ? false : true"
          >
            <b-form-input
              v-model="form.password"
              type="password"
              required
              placeholder="Password"
              :disabled="hasNoToken"
              :state="typeof formErrors.password !== 'undefined' ? false : null"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Confirm Password"
            label-for="confirmPassword"
            :invalid-feedback="formErrors.confirmPassword"
            :state="
              typeof formErrors.confirmPassword !== 'undefined' ? false : true
            "
          >
            <b-form-input
              v-model="form.confirmPassword"
              type="password"
              required
              placeholder="Confirm Password"
              :disabled="hasNoToken"
              :state="
                typeof formErrors.confirmPassword !== 'undefined' ? false : null
              "
            ></b-form-input>
          </b-form-group>
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-block"
          :disabled="hasNoToken"
        >
          Accept Invite
        </button>
          <b-alert variant="danger" v-model="hasErrors" style="margin-top: 20px">{{
            error.msg
          }}</b-alert>
      </b-form>
      <div v-else>
        <b-alert variant="success" v-model="successMessage"
          >Invite accepted! <br />
          <span :style="{ 'font-size': '10px' }"
            >Redirecting to home page in {{ redirectTimer }}s</span
          ></b-alert
        >
        <p
          :style="{ padding: '20px 0 0 0' }"
          v-if="
            subDomain === 'driver' ||
            subDomain === 'workplaces' ||
            subDomain === 'workplaces-staging' ||
            subDomain === 'driver-staging'
          "
        >
          <router-link to="/sign-in">Sign In</router-link>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import shebahApi from "@/services/shebah/index";

export default {
  name: "signIn",
  components: {},
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    },
    stateOptions() {
      return this.$store.getters["general/states"];
    },
    subDomain() {
      return this.$store.getters["general/subDomain"];
    },
  },
  watch: {},
  data() {
    return {
      inviteData: {},
      form: {
        password: "",
        confirmPassword: "",
      },
      hasNoToken: false,
      hasErrors: false,
      successMessage: false,
      error: {},
      formErrors: {},
      redirectTimer: 60,
      redirectTimerInterval: null,
      redirectTimeout: null,
    };
  },
  beforeCreate() {
    this.$cookie.delete("_t");
    this.$store.dispatch("authUser/updateUser", null);
    this.$store.dispatch("authUser/token", null);
    let body = document.getElementsByTagName("BODY")[0];
    // reset body class attribute
    body.className = "";
    body.classList.add("animsition");
    body.classList.add("page-forgot-password");
    body.classList.add("layout-full");
  },
  beforeDestroy() {
    clearInterval(this.redirectTimerInterval);
    clearTimeout(this.redirectTimeout);
  },
  async created() {
    await this.getToken();
  },
  methods: {
    async getToken() {
      try {
        if (
          typeof this.$route.query !== "undefined" &&
          typeof this.$route.query.token !== "undefined" &&
          this.$route.query.token !== ""
        ) {
          this.errorMessage = "";
          this.inviteData = await shebahApi.api.users.inviteToken(
            this.$route.query.token
          );
          this.form = { ...this.inviteData };
        } else {
          this.hasNoToken = true;
          this.hasErrors = true;
          this.error.msg = "No token supplied!";
        }
      } catch (e) {
        if (typeof e.response !== "undefined") {
          this.error = e.response.data.error;
          this.hasErrors = true;
        } else {
          console.error(e);
        }
      }
    },
    async onSubmit() {
      try {
        this.errorMessage = "";
        this.error = {};
        this.formErrors = {};
        this.hasErrors = false;

        if (!this.inviteData.status) {
          if (this.form.password === "") {
            this.formErrors.password = "Password can not be blank!";
          }

          if (this.form.password.length < 8) {
            this.formErrors.password =
              "Password can not be less than 8 characters long!";
          }

          if (this.form.confirmPassword === "") {
            this.formErrors.confirmPassword =
              "Confirm password can not be blank!";
          }

          if (this.form.password !== this.form.confirmPassword) {
            this.formErrors = {
              confirmPassword: "Password and Confirm password do not match!",
            };
          }
        }

        if (Object.keys(this.formErrors).length == 0) {
          console.log(this.form);
          let forgotPassword = await shebahApi.api.users.acceptInvite(
            this.$route.query.token,
            this.form
          );
          this.hasErrors = false;
          this.successMessage = true;
          this.form.password = "";
          this.form.confirmPassword = "";
          this.redirectTimerInterval = setInterval(() => {
            this.redirectTimer = this.redirectTimer - 1;
          }, 1000);
          this.redirectTimeout = setTimeout(() => {
            this.$router.push({ path: "/" });
            clearInterval(this.redirectTimerInterval);
          }, 60000);
        }
      } catch (e) {
        if (typeof e.response !== "undefined") {
          this.error = e.response.data.error;
          if (typeof this.error.collection !== "undefined") {
            this.formErrors = this.error.collection;
          }
          this.successMessage = false;
          this.hasErrors = true;
        } else {
          console.error(e);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.page-login-main {
  &.page-sigup-main {
    padding: 60px;
  }
}
</style>
